import { take, fork } from 'redux-saga/effects';
import { centrifugoInitializer } from '../centrifugo';
import { commonNavbar } from '../navbar';
import { commonSentry } from '../sentry';
import { setHostClassName } from '../render';
import { abaExtraDataWatcher } from '../latestsABARequests';
import { GROWTHBOOK_LOADED } from '../../constants/experiment';
import { getLayoutDimensions } from '../changeLayoutDimensions';
import { themeWatcher } from '../themes';

// we need listener for things, that are base on features, f.e. big-wins
export function* growthbookWatcher() {
  yield take(GROWTHBOOK_LOADED);

  yield fork(abaExtraDataWatcher);

  yield fork(themeWatcher);
  // connecting to centrifugo
  yield fork(centrifugoInitializer);

  yield fork(commonNavbar);

  yield fork(commonSentry);

  // set host className (if host is not default)
  yield fork(setHostClassName);

  // trigger for getting UI params
  yield fork(getLayoutDimensions);
}
